import { useContext } from 'react';
import { useMutableCallback } from '@slope/hooks';
import { FloatingPanelContext } from './FloatingPanelContext';

// Hook for tooltip usage
export const useFloatingPanel = <TOptions = unknown>(id: string, options?: TOptions) => {
  const context = useContext(FloatingPanelContext);
  if (!context) throw new Error('useFloatingPanel must be used within a FloatingPanelProvider');

  const { registerPanel, unregisterPanel, collisionStrategy } = context;

  const setElement = useMutableCallback<<T extends HTMLElement>(el: T | null) => () => void>(
    (element) => {
      if (element) {
        registerPanel(id, element, options);
      } else {
        unregisterPanel(id);
      }

      return () => unregisterPanel(id);
    },
  );

  return { setElement, collisionStrategy, node: collisionStrategy.get(id) ?? null };
};
